import styled from 'styled-components';

export const Main = styled.main`
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 80px;
`;
